// extracted by mini-css-extract-plugin
export default {"thirdsection":"Third_thirdsection__2XbIs","title":"Third_title__C0xg1","schools":"Third_schools__Xbbn4"};